'use strict';

function FeaturesProgress() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.declaredClass = null;
  this.extends = [InView];
  this.set = true;

  this.el = {};
  this._classes = {
    feature: '.marketing-features-progress__feature',
    featureNumber: '.js--feature-in-view',
    features: '.marketing-features-progress__features',
    featureInView: 'marketing-features-progress__feature--in-view',
    featuresInView: 'marketing-features-progress__features--in-view',
    jsHeading: '.js--features-progress-heading'
  };

  this.init = function () {
    this.$node = $(this.node);
    this.el.featureNumbers = this.$node.find(this._classes.featureNumber);
    this.el.features = this.$node.find(this._classes.features);
    this.el.heading = this.$node.find(this._classes.jsHeading);
    this._initProgress();
    this._animateFeatures();
  };

  this.initAllReady = function () {};

  this._initProgress = function () {
    var _this = this;

    // We use the heading to check if the section is in view because we currently can't nest 'inView' items
    this.el.heading.bind('inViewBottom', function () {
      _this.el.features.addClass(_this._classes.featuresInView);
    });

    this.el.heading.bind('outOfViewBottom', function () {
      _this.el.features.removeClass(_this._classes.featuresInView);
    });
  };

  this._animateFeatures = function () {
    var _this = this;

    this.el.featureNumbers.each(function () {
      var $this = $(this);

      $this.bind('inViewElementBottom', function () {
        $this.parent(_this._classes.feature).addClass(_this._classes.featureInView);
      });
    });
  };
}